export const DASHBOARD_HEADER_TITLE = 'DASHBOARD_HEADER_TITLE';

export const configHeader = dashboard => ({
  type: DASHBOARD_HEADER_TITLE,
  ...dashboard,
});
